import React, { useState } from 'react';
import { TouchableOpacity } from 'react-native';
import { Typography } from '@hmsexp/component-library';
import { Text } from '../../../components/Common/react-native-components';

const getComparatorFn = direction => {
  switch (direction) {
    case 'gt':
      return (a, b) => a > b;
    case 'gte':
      return (a, b) => a >= b;
    case 'lt':
      return (a, b) => a < b;
    case 'lte':
      return (a, b) => a <= b;
    case 'eq':
      return (a, b) => a === b;
    case 'neq':
      return (a, b) => a !== b;
    default:
      return (a, b) => a < b;
  }
};

const DataCell = ({ column, row, setRowHovered, hoveredRowId }) => {
  const { type = 'text', threshold, compositeFields, rules, onPress } = column;

  const [hover, setHover] = useState(false);
  const rowHovered = hoveredRowId === row.topic;
  if (row.topic.includes('-')) console.log(rowHovered, row, hoveredRowId, 'kjsk');

  let displayValue = row[column.field];

  if (type === 'composite' && Array.isArray(compositeFields)) {
    displayValue = compositeFields.map(f => row[f]).join(' / ');
  }

  let textColor = '#000';
  let backgroundColor = rowHovered ? '#f4f9ff' : 'transparent';
  const isSortable = column.sortable === true;

  const isBelowThreshold =
    type === 'threshold' && threshold
      ? getComparatorFn(threshold.direction)(row[threshold.field], threshold.value)
      : false;

  if (type === 'score' && Array.isArray(rules)) {
    const scoreValue = Number(displayValue);
    for (const rule of rules) {
      const compareFn = getComparatorFn(rule.direction);
      if (compareFn(scoreValue, rule.value)) {
        textColor = rule.color ?? textColor;
        backgroundColor = rule.backgroundColor ?? backgroundColor;
        break;
      }
    }
  }

  if (type === 'link') {
    textColor = '#266ec9';
  }
  return (
    <TouchableOpacity
      onMouseEnter={() => {
        setHover(true);
        console.log('kjski', row.topic);
        setRowHovered(row.topic);
      }}
      onMouseLeave={() => {
        setHover(false);
        setRowHovered(null);
      }}
      onPress={() => {
        if (type === 'link' && typeof onPress === 'function') {
          onPress(row);
        }
      }}
      disabled={type !== 'link'}
      style={{
        height: '100%',
        flex: 1,
        justifyContent: 'center',
        alignItems: isSortable ? 'flex-end' : 'flex-start',
        paddingHorizontal: 8,
        backgroundColor
      }}
      activeOpacity={type === 'link' ? 0.3 : 1}>
      <Text
        variant='body2'
        fontWeightType='medium'
        style={{
          color: isBelowThreshold ? '#d51b26' : textColor,
          textDecorationLine: type === 'link' && hover ? 'underline' : 'none',
          cursor: type === 'link' ? 'pointer' : 'default'
        }}>
        {displayValue ?? '--'}
      </Text>
    </TouchableOpacity>
  );
};

export default DataCell;
